import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import { useI18n } from "@/i18n/I18nProvider";

const containerSx = {
  display: { xs: "flex", sm: "none" },
  px: 2,
  flexDirection: "row",
  alignItems: "center",
  gap: 1.5,
  overflowX: "auto",
  overflowY: "hidden",
  whiteSpace: "nowrap",
  borderBottom: "2px solid #F18222",
  backgroundColor: "#EBEBED",
  minHeight: "57px", // reserve space to reduce CLS
  WebkitOverflowScrolling: "touch",
  contain: "layout paint",
};

const linkSx = {
  textDecoration: "none",
  color: "#252C32",
  whiteSpace: "nowrap",
  flexShrink: 0,
  cursor: "pointer",
  minHeight: "57px",
  px: 1,
  display: "inline-flex",
  alignItems: "center",
  WebkitTapHighlightColor: "transparent",
};

const textSx = {
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: 1.2,
  color: "#252C32",
};

function HomepageNavigation() {
  const { t } = useI18n();

  const items = useMemo(() => t.home_page.sec_navigation ?? [], [t]);

  return (
    <Box component="nav" aria-label="Homepage sections" sx={containerSx}>
      {items.map((item) => (
        <Box
          key={item.url || item.title}
          component="a"
          href={item.url}
          sx={linkSx}
        >
          <Box component="span" sx={textSx}>
            {item.title}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default memo(HomepageNavigation);